import { render } from "./SimulationOption.vue?vue&type=template&id=87d0717e&ts=true"
import script from "./SimulationOption.vue?vue&type=script&lang=ts"
export * from "./SimulationOption.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__